'use client'
import React from 'react'
import { Director } from '@/cinematics/Director'
import { AuthActor } from '@/actors/AuthActor'
import { LAYOUT_TYPE, STANDARD_AUTH_FORMS } from '@/constants/auth'
import { Layout } from '@/components/UI/Layout'

const LoginPage = (props: any) => {
  const { children } = props

  return (
    <Layout
      hasMarginX={false}
      hasFooter={false}
      hasNavbar={true}
      hasMinimalNavbar={true}
      isFullWidth={true}
    >
      <Director
        ActorComponents={
          (props) => <AuthActor
            /* @next-codemod-error 'props' is used with spread syntax (...). Any asynchronous properties of 'props' must be awaited when accessed. */
            {...props}
            initialLayoutType={LAYOUT_TYPE.DOUBLE_COLUMN}
            initialAuthForm={STANDARD_AUTH_FORMS.MAIN}
          />
        }
        defaultSceneId='Auth'
      >
        {children}
      </Director>
    </Layout>
  );
}

export default LoginPage